/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailBookingDialogController', ProjectDetailBookingDialogController);

    ProjectDetailBookingDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'entity2', 'ProjectDetailBooking'];

    function ProjectDetailBookingDialogController ($timeout, $scope, $uibModalInstance, entity, entity2, ProjectDetailBooking) {
        var vm = this;

        vm.booking = entity2;
        vm.nickname = vm.booking.nickname ? " \"" + vm.booking.nickname + "\"" : "";
        vm.booking.oldStatus = vm.booking.status;
        vm.booking.oldIndividualPrice = vm.booking.individualPrice;
        vm.booking.nonIndividual = !vm.booking.individualPrice;
        vm.project = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.booking.individualPrice = !vm.booking.nonIndividual;
            ProjectDetailBooking.update(vm.booking, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:bookingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
